import React from 'react';
import { View, StyleSheet, Image, TouchableOpacity } from 'react-native';
import { Text, Avatar, useTheme } from 'react-native-paper';
import { formatName } from '../utils';

const ProfileHeader = ({ user, onEditPress }) => {
  const theme = useTheme();
  
  // Default avatar 
  const getInitials = (name, surname) => {
    if (!name && !surname) return 'U';
    
    const firstInitial = name ? name.charAt(0).toUpperCase() : '';
    const lastInitial = surname ? surname.charAt(0).toUpperCase() : '';
    
    return `${firstInitial}${lastInitial}`;
  };
  
  return (
    <View style={styles.container}>
      <View style={styles.headerContent}>
        {user?.photoUrl ? (
          <Avatar.Image 
            source={{ uri: user.photoUrl }} 
            size={90} 
            style={styles.avatar}
            
          />
        ) : (
          <Avatar.Text 
            label={getInitials(user?.name, user?.surname)} 
            size={90} 
            style={styles.avatar}
            labelStyle={styles.avatarLabel}
            color="#fff"
            backgroundColor={theme.colors.primary}
          />
        )}
        
        <View style={styles.userInfoContainer}>
          <Text style={styles.fullName}>
            {user?.name && user?.surname 
              ? formatName(`${user.name} ${user.surname}`)
              : 'Kullanıcı'}
          </Text>
          
          {user?.email && (
            <Text style={styles.email} numberOfLines={1}>
              {user.email}
            </Text>
          )}
          
          {user?.phone && (
            <Text style={styles.phone} numberOfLines={1}>
              {user.phone}
            </Text>
          )}
        </View>
      </View>
      
      {onEditPress && (
        <TouchableOpacity 
          style={[styles.editButton, { backgroundColor: theme.colors.primary }]}
          onPress={onEditPress}
        >
          <Text style={styles.editButtonText}>Profili Düzenle</Text>
        </TouchableOpacity>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 16,
    paddingVertical: 24,
    backgroundColor: '#fff',
    borderRadius: 12,
    marginBottom: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 2,
  },
  headerContent: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  avatar: {
    marginRight: 16,
    
  },
  avatarLabel: {
    fontSize: 32,
    fontWeight: 'bold',
  },
  userInfoContainer: {
    flex: 1,
  },
  fullName: {
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 4,
  },
  email: {
    fontSize: 14,
    color: '#555',
    marginBottom: 2,
  },
  phone: {
    fontSize: 14,
    color: '#777',
  },
  editButton: {
    marginTop: 16,
    paddingVertical: 8,
    borderRadius: 8,
    alignItems: 'center',
  },
  editButtonText: {
    color: '#fff',
    fontWeight: '500',
  },
});

export default ProfileHeader;
